/** Track foreground use without recording interaction contents. */
export function startActivityTracker(send: (beat: { beatId: string; elapsedMs: number }) => Promise<unknown>) {
  let interaction = Date.now(), previous = Date.now(), running = false, wasActive = false;
  const interact = () => { interaction = Date.now(); };
  const tick = () => {
    const now = Date.now();
    const active = document.visibilityState === "visible" && now - interaction < 120_000;
    const elapsedMs = active && wasActive ? Math.min(20_000, now - previous) : 0;
    previous = now;
    wasActive = active;
    if (!active || running) return;
    running = true;
    void send({ beatId: crypto.randomUUID(), elapsedMs }).catch(() => undefined).finally(() => { running = false; });
  };
  const visibility = () => { if (document.visibilityState === "visible") interact(); tick(); };
  const events = ["pointerdown", "pointermove", "keydown", "scroll", "touchstart"] as const;
  events.forEach((event) => window.addEventListener(event, interact, { passive: true }));
  document.addEventListener("visibilitychange", visibility);
  tick();
  const timer = window.setInterval(tick, 15_000);
  return () => {
    clearInterval(timer);
    events.forEach((event) => window.removeEventListener(event, interact));
    document.removeEventListener("visibilitychange", visibility);
  };
}
